'use client';

import { useTranslation } from '@/features/i18n';
import { logger } from '@/utils/loggerUtils';
import { useEffect } from 'react';
import { Button } from './buttons/Button';

export const ErrorMessageDisplay = ({
  error,
  reset,
}: {
  error?: Error & { digest?: string };
  reset?: () => void;
}) => {
  const { t } = useTranslation();

  if (window.location.hostname === 'localhost') throw error as Error;

  useEffect(() => {
    logger.error(error);
  }, [error]);

  return (
    <main className="flex h-full min-h-[400px] flex-col items-center justify-center">
      <h2 className="mb-3 text-center">{t('something-went-wrong')}</h2>
      {reset && (
        <Button
          icon="error"
          onClick={
            // Attempt to recover by trying to re-render the invoices route
            () => reset()
          }
        >
          {t('try-again')}
        </Button>
      )}
    </main>
  );
};
